{
  "es": {
    "meta": {
      "description": "FleetYards.net, Your Database for all Information related to Ships from “Star Citizen“.",
      "keywords": "Star Citizen, Spaceships, Ships, Fighter, Database, Squadron, 42, Star, Citizen, English, Chris, Roberts, Online, Game, Space, Simulation"
    },
    "model": {
      "focus": "Enfoque",
      "classification": "Clasificación",
      "size": "Tamaño",
      "beam": "Manga",
      "cargo": "Carga",
      "netCargo": "Carga con Rover/Snub",
      "crew": "Tripulación",
      "speed": "Velocidad",
      "minCrew": "Tripulación mín.",
      "maxCrew": "Tripulación máx.",
      "scmSpeed": "SCM Speed",
      "scmSpeedBoosted": "SCM Speed Boosted",
      "reverseSpeedBoosted": "Reverse Speed Boosted",
      "maxSpeed": "Velocidad máx.",
      "scm": "SCM",
      "max": "Máx",
      "groundMaxSpeed": "Velocidad máx.",
      "groundReverseSpeed": "Velocidad de reversa",
      "pitch": "Pitch",
      "pitchBoosted": "Cabeceo potenciado",
      "yaw": "Yaw",
      "yawBoosted": "Guiñada potenciada",
      "roll": "Roll",
      "rollBoosted": "Balanceo potenciado",
      "price": "Precio",
      "groundAcceleration": "Aceleración",
      "groundDecceleration": "Deceleración",
      "scmSpeedAcceleration": "Cero a SCM",
      "scmSpeedDecceleration": "SCM a Cero",
      "maxSpeedAcceleration": "Cero a Máx",
      "maxSpeedDecceleration": "Máx a Cero",
      "compare": {
        "groundMaxSpeed": "Velocidad terrestre máx.",
        "groundReverseSpeed": "Velocidad terrestre de reversa",
        "groundAcceleration": "Aceleración terrestre",
        "groundDecceleration": "Deceleración terrestre"
      },
      "pledgePrice": "Precio de Pledge",
      "quantumFuelTankSize": "Combustible Quantum",
      "hydrogenFuelTankSize": "Combustible",
      "height": "Altura",
      "length": "Longitud",
      "mass": "Masa",
      "manufacturer": "Fabricante",
      "hardpoints": "Puntos de montaje",
      "weapons": "Armas",
      "equipment": "Equipamiento",
      "variants": "Variantes",
      "maxUpgrades": "Mejoras",
      "productionStatus": "Estado de producción",
      "propulsion": "Propulsión",
      "ordnance": "Armamento",
      "modular": "Modular",
      "soldAt": "¿Vendido en?",
      "rentalAt": "¿Alquilado en?",
      "poweredByUex": "Con tecnología de UEX",
      "lastUpdatedAt": "¿Última actualización?"
    },
    "component": {
      "manufacturer": "Fabricante",
      "size": "Tamaño"
    },
    "availability": {
      "listedAt": "Listed at",
      "soldAt": "Sold at",
      "boughtAt": "Bought at"
    },
    "resources": {
      "models": "Naves",
      "hardpoints": "Puntos de montaje",
      "images": "Imágenes"
    },
    "pagination": {
      "previous": "Previous Page",
      "next": "Next Page",
      "gap": "&hellip;"
    }
  }
}
